<template>
  <div class="content_section gp_signature">
                <div class="group_info">
                  <h2>Signature & Verification</h2>
                  <form class="" action="index.html" method="post">
                    <div class="input_box verification">
                      <label for="">Verification Code <span class="red">*</span></label>
                      <div class="capcha half">
                        <div class="capcha_box">
                          <img src="images/capcha.png" alt="Corenroll">
                        </div>
                      </div>
                      <div class="inputs half">
                        <input type="text" name="" value=""/>
                      </div>
                    </div>
                    <div class="input_box half ">
                      <label for="">Full Name<span class="red">*</span></label>
                      <div class="inputs">
                        <input type="text" name="" value=""/>
                        <p>Type your full name which will be your "signature" to verify application terms and agreement</p>
                      </div>
                    </div>
                    <div class="input_box half ">
                      <label for="">Signature Date</label>
                      <div class="inputs">
                        <input type="text" name="" value=""/>
                      </div>
                    </div>
                    <div class="buttonbox">
                      <button @click="navigatePrevious" class="previous" type="button" name="button">Previous</button>
                      <button class="reset" type="button" name="button">Reset</button>
                      <button class="submit" type="button" name="button">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
</template>
<script>
export default {
    name: "SignatureVerification",
    props: {
      navdata: {
        type: Array
      }
    },
    methods: {
      saveAndContinue() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigation', this.$route.name);
      },
      navigatePrevious() {
        //Update APIs
        //Navigate to next page
        this.$emit('comEnvNavigationBack', this.$route.name);
      },
    }
  }
</script>
